import {
  IconPlus,
  IndigoIndigo60,
  Primary13SemiBold,
  SimpleTableInput,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import { Currency } from '@sequencehq/api'
import { PriceEditorTier } from 'common/drawers/PricingEditor/domain'
import { ValidationError } from '@sequencehq/utils'
import { useSeatBasedTierInput } from './useSeatBasedTierInput'

type SeatBasedTierInputProps = {
  onChange: (value: PriceEditorTier[]) => void
  value: PriceEditorTier[]
  isDisabled: boolean
  currency: Currency
  validationErrors: ValidationError[]
}

export const SeatBasedTierInput: FC<SeatBasedTierInputProps> = props => {
  const { fieldConfig, addNewTier } = useSeatBasedTierInput(props)

  return (
    <>
      <SimpleTableInput {...fieldConfig} data-testid="seat.tiers" />
      <Flex justifyContent="center" marginTop="8px">
        <Flex
          {...Primary13SemiBold}
          width="fit-content"
          color={IndigoIndigo60}
          onClick={() => addNewTier()}
          _hover={{ opacity: 0.7 }}
          cursor="pointer"
          padding="4px 0"
          alignItems="center"
          data-testid="seat.tiers.addTier"
          gap="4px"
        >
          <IconPlus /> Add another tier
        </Flex>
      </Flex>
    </>
  )
}
